import { z } from 'zod'

export const OutstandingTransactionsComingSoonSchema = z.nullable(
  z.object({
    displayModal: z.literal(true),
  })
)

export const OutstandingTransactionsComingSoonLocationSchema = z.object({
  OutstandingTransactionsComingSoonModal:
    OutstandingTransactionsComingSoonSchema,
})

export type OutstandingTransactionsComingSoonState = z.TypeOf<
  typeof OutstandingTransactionsComingSoonSchema
>
